<template>
  <div class="field number">
    <span v-if="label"
          class="label text-right"
          :class="labelClass"
    >
      {{ label }}
    </span>

    <div class="value v-align"
         :class="valueClass"
    >
      <b-badge :class="badgeClass">
        {{ value }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import bBadge from 'bootstrap-vue/es/components/badge/badge'

export default {
  components: {
    bBadge
  },
  props: {
    value: {
      type: Number
    },
    label: String,
    minThreshold: {
      type: Number,
      default: -1
    },
    maxThreshold: {
      type: Number,
      default: 1
    },
    width: String
  },
  computed: {
    valueClass: function () {
      if (this.label) {
        return 'col-8'
      }
    },
    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    },
    badgeClass: function () {
      return this.value <= this.minThreshold ? 'bg-danger'
        : this.value >= this.maxThreshold ? 'bg-success'
          : 'bg-warning'
    }
  }
}
</script>
